export enum EventAssessmentClass {
    Unknown = 0,
    NoClassificationNeeded = 1,
    NoAssessmentNeeded = 2,
    NoMeasureNeeded = 3,
    MeasureTaken = 4,
}
